import React, { useEffect, useRef, useState } from "react";
import config from "../../config";
import { triggerNotification } from "../../component/message/Msg";
import Swal from "sweetalert2";
import Breadcrumb from "../../component/breadcrumb/Breadcrumb";
import { useNavigate } from "react-router-dom";
import Spinner from "../../component/loadingbar/Spinner";
import Export from "../../component/Export";
import TableViewer from "../../component/tableViewer/TableViewer";

const ViewTeachers = () => {
  const [teachers, setTeachers] = useState([]);
  const [loading, setLoading] = useState(false);
  const token = config.token;
  const navigate = useNavigate();

  //  ------For TableViewer ------
  const teachersRef = useRef([]);
  teachersRef.current = teachers;
  const [rowData, setRowData] = useState([]);
  //  ------For TableViewer ------

  //----------------------------------------------- Export xlsx File ----------------------------------------------
  const handleExport = () =>
    teachers.map((teacher) => {
      return {
        First_name: teacher.fname,
        Last_name: teacher.lname,
        Email: teacher.email,
        Mobile_no: teacher.mobileno,
        Address: teacher.address,
        Image: teacher.image,
        Gender: teacher.gender,
        DOB: teacher.dob,
      };
    });

  //----------------------------------------------- select / view teachers table  -------------------------------------------------R
  // Fetch all teachers
  const fetchTeachers = async () => {
    setLoading(true);
    try {
      await fetch(`${config.host_url}teacher`, {
        method: "GET",
        headers: {
          token: token,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.status === 200) {
            // Successful response, update the teachers state

            //  ------For TableViewer ------
            const approvedTeachers = data.data.filter(
              (teacher) => teacher.isApproved === 1
            );
            setTeachers(approvedTeachers);
            const teachersData = approvedTeachers.map((teacher) => ({
              teacher: teacher.fname + " " + teacher.lname,
              email: teacher.email,
              image: teacher.image,
              mobile: teacher.mobileno,
              idNumber: teacher.tid,
            }));
            setRowData(teachersData);
            //  ------For TableViewer ------
          } else if (data.status === 401) {
            // Invalid token
            triggerNotification("error", "Unauthenticated user");
          } else {
            // Handle other errors
            triggerNotification(
              "error",
              "Internal server error, Please try after some time!!"
            );
          }
        });
    } catch (error) {
      triggerNotification("error", "Error fetching teachers.");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchTeachers();
  }, [token]);

  // ---------------------------------------------------- Delete Teacher ---------------------------------------------------------D
  // Show a confirmation dialog
  const btnDeleteHandle = (deleteId, i) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You are about to delete Teacher. Are you sure you want to proceed?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        handleDeleteTeacher(deleteId, i);
      }
    });
  };

  //If confirm then delete Teacher
  const handleDeleteTeacher = async (deleteId, i) => {
    try {
      await fetch(`${config.host_url}teacher/${deleteId}`, {
        method: "DELETE",
        headers: {
          token: token,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.status === 200) {
            triggerNotification("success", "Teacher deleted successfully.");

            //  ------For TableViewer ------
            const updatedTeachers = [...teachersRef.current];
            updatedTeachers.splice(i, 1);
            const approvedTeachers = updatedTeachers.filter(
              (teacher) => teacher.isApproved === 1
            );
            setTeachers(approvedTeachers);
            const teachersData = approvedTeachers.map((teacher) => ({
              teacher: teacher.fname + " " + teacher.lname,
              email: teacher.email,
              image: teacher.image,
              mobile: teacher.mobileno,
              idNumber: teacher.tid,
            }));
            setRowData(teachersData);

            //  ------For TableViewer ------
          } else if (data.status === 401) {
            // Invalid Token
            triggerNotification("error", "Unauthenticated User");
          } else {
            // Internal Server Error or other HTTP errors
            triggerNotification(
              "error",
              "Internal server error, Please try after some time!"
            );
          }
        });
    } catch (error) {
      triggerNotification("error", "Error deleting teacher");
    }
  };

  //----------------------------------------------- select / view teachers table  -------------------------------------------------R
  const btnShowHandle = (id) => {
    const encodedId = window.btoa(encodeURIComponent(id));
    navigate(`/viewteacher/${encodedId}`);
  };

  //----------------------------------------------- update / edit teachers table  -------------------------------------------------R
  const btnEditHandle = (id) => {
    const encodedId = window.btoa(encodeURIComponent(id));
    navigate(`/addteacher/${encodedId}`);
  };

  //  ------For TableViewer ------
  const colDefs = [
    {
      headerName: "#",
      width: 50,
      valueFormatter: (params) => {
        return `${parseInt(params.node.id) + 1}`;
      },
    },
    {
      headerName: "Teacher",
      field: "teacher",
      width: 300,
      cellRenderer: (params) => (
        <div className=" flex py-1 ">
          <img
            src={params.data.image}
            alt="Teacher_Image"
            className="rounded h-11 w-11  bg-gray-300 mr-4"
          />
          <p className="p-0 m-0">{params.data.teacher}</p>
        </div>
      ),
    },
    // { field: "teacher", filter: true },
    { field: "email", filter: true, width: 250 },
    { field: "mobile", filter: true },
  ];
  //  ------For TableViewer ------

  return (
    <>
      <Breadcrumb txt="Manage Teacher" subpath={["View Teachers"]} />
      <div className="col-xxl">
        <div className="card mb-4">
          <div className="card-header d-flex align-items-center row flex justify-between">
            <h5 className="mb-0 col-sm-3">View Teachers</h5>
            <div className="col-sm-3 flex justify-end mt-2">
              <Export onExport={handleExport} teacher />
              <button
                type="button"
                className="btn btn-primary ml-4"
                onClick={() => {
                  navigate("/addteacher");
                }}
              >
                Add Teacher
              </button>
            </div>
          </div>
          {loading ? (
            <Spinner />
          ) : (
            <div className="px-3 pb-3  table-responsive">
              {/* ------For TableViewer ------ */}
              <TableViewer
                rowData={rowData}
                colDefs={colDefs}
                onEdit={btnEditHandle}
                onDelete={btnDeleteHandle}
                onView={btnShowHandle}
                tableTitle="View Teachers"
                // haveImage
              />
              {/* ------For TableViewer ------ */}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ViewTeachers;
